/*** kit - Section Scripts ***/

(function (window) {
  const kits = document.querySelectorAll('[data-kit-quick-buy-button]');
  if (kits && kits.length > 0) {
    kits.forEach((kit) => {
      kit.addEventListener('click', (e) => {
        const kitSection = kit.closest('.kit__container');

        if (!kitSection) {
          console.warn('Could not find kit section! Exiting...');
          return;
        }

        const kitQuickBuy = kitSection.querySelector('.quick-add__submit[type="submit"]');

        if (!kitQuickBuy) {
          console.warn('Could not find kit quick buy button! Exiting...');
          return;
        }

        kitQuickBuy.click();
      });
    });
  }
})(window);
